import React from 'react';
import './SummaryLoadingOverlay.css';

const SummaryLoadingOverlay = ({ isDarkMode = false }) => {
  return (
    <div className={`summary-loading-overlay ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="summary-loading-content">
        {/* Loading Spinner */}
        <div className="summary-loading-spinner"></div>
        
        {/* Loading Text */}
        <div className="summary-loading-text">
          Regenerating summary
          <div className="summary-loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        
        {/* Subtext */}
        <div className="summary-loading-subtext">
          This may take a moment while we fetch the latest content...
        </div>
        
        {/* Summary Skeleton Structure */}
        <div className="summary-skeleton-container">
          {/* Article Title Skeleton */}
          <div className="skeleton-line summary-skeleton-title"></div>
          
          {/* Author Section Skeleton */}
          <div className="summary-skeleton-author-section">
            <div className="skeleton-circle summary-skeleton-author-avatar"></div>
            <div className="summary-skeleton-author-info">
              <div className="skeleton-line summary-skeleton-author-name"></div>
              <div className="skeleton-line summary-skeleton-author-meta"></div>
            </div>
          </div>
          
          {/* Content Skeleton */}
          <div className="summary-skeleton-content">
            {/* Paragraphs */}
            <div className="skeleton-line summary-skeleton-paragraph long"></div>
            <div className="skeleton-line summary-skeleton-paragraph medium"></div>
            <div className="skeleton-line summary-skeleton-paragraph short"></div>
            
            {/* Subheading */}
            <div className="skeleton-line summary-skeleton-heading"></div>
            
            {/* More paragraphs */}
            <div className="skeleton-line summary-skeleton-paragraph medium"></div>
            <div className="skeleton-line summary-skeleton-paragraph long"></div>
            <div className="skeleton-line summary-skeleton-paragraph short"></div>
            
            {/* Another subheading */}
            <div className="skeleton-line summary-skeleton-heading"></div>
            
            {/* Final paragraphs */}
            <div className="skeleton-line summary-skeleton-paragraph long"></div>
            <div className="skeleton-line summary-skeleton-paragraph medium"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryLoadingOverlay;
